<template>
    <div>
        <ContentLink :href="tutorial.content_url">
            <ContentImage :src="tutorial.image_url"></ContentImage>
            <Title>{{tutorial.title}}</Title>
        </ContentLink>
        <UserInfo :memberName="tutorial.author.name" :memberUrl="tutorial.author.profile_url" :avatarUrl="tutorial.author.avatar_url"></UserInfo>
        <div class="card-counter-container">
            <Counter :value="tutorial.likes_count" kind="like"></Counter>
            <Counter :value="tutorial.comments_count" kind="comment"></Counter>
            <Counter :skill="tutorial.level" kind="level"></Counter>
        </div>
        <UserInfo></UserInfo>
        <ContentTags :tags="tutorial.tags"></ContentTags>
    </div>
</template>

<script>
    import ContentImage from '../shared/card/ContentImage'
    import ContentTags from '../shared/ContentTags'
    import ContentLink from '../shared/card/ContentLink'
    import UserInfo from '../shared/card/UserInfo'
    import Counter from '../shared/card/Counter'
    import Title from '../shared/card/Title'


    export default {
        name: 'Tutorial',
        props: {
            tutorial: Object
        },
        components: {
            ContentImage,
            UserInfo,
            ContentLink,
            ContentTags,
            Title,
            Counter
        }
    }
</script>